import React from 'react';

const CartEmpty = ({ ctaText, ctaLink, message }) => (
  <div className="flex flex-grow flex-col items-center justify-center px-4 pb-[7.5rem] pt-24 lg:pt-14">
    {!!message?.length && (
      <div
        className="body-1 mb-3 text-center"
        data-target="text-content"
        dangerouslySetInnerHTML={{ __html: message }}
      ></div>
    )}
    {!!ctaText && !!ctaLink && (
      <div>
        <a
          className="button button--primary w-full justify-center self-center"
          href={ctaLink}
        >
          {ctaText}
        </a>
      </div>
    )}
  </div>
);

export default CartEmpty;
